import { css } from "@emotion/react";
import { MOBILE } from "../../constants/breakpoints";
import success_icon from "../../assets/success_icon.svg";
import colors from "../../constants/colors";
import { useSelector } from "react-redux";
import { shortenAddress } from "../../utils/shortenAddress";
import { ReactComponent as CheckIcon } from "../../assets/check.svg";
import copy_icon from "../../assets/icons/copy_small.svg";
import { useState } from "react";
import { DataContainer, Dots, InfoContainer } from "./style";


export const DataSection = () => {
    let selectedAssetInfo = useSelector(
        (state: any) => state.walletState.selectedAssetInfo
    );

    if (!selectedAssetInfo) {
        return <p>loading...</p>;
    }
    return (
        <DataContainer>
            <div className="topSection">
                <span className="textSpan">
                    <h1
                        className="h1Text"
                    >
                        Proxy Token Mint Signature Info
                    </h1>
                </span>
                <img
                    className="icon-image"
                    src={success_icon}
                    alt="" />
            </div>
            <div className="bottomSection">
                {["Contract Address", "Token ID", "Token Standard", "Blockchain"].map(
                    (info) => {
                        let labelMap: any = {
                            "Contract Address": "token_address",
                            "Token ID": "token_id",
                            "Token Standard": "",
                            Blockchain: "",
                        };
                        let value = selectedAssetInfo[labelMap[info]] || "N/A";
                        if (info === "Blockchain") {
                            let chain = window.location.pathname.split("/")[2];
                            if (chain == "ETH") {
                                value = "Ethereum";
                            }
                            if (chain == "POLYGON") {
                                value = "Polygon";
                            }
                        }
                        return (
                            <InfoTag
                                label={info}
                                value={value}
                                title={info === "Contract Address" ? shortenAddress(value) : ''}
                                key={"info" + info}
                            />
                        );
                    }
                )}
            </div>
        </DataContainer>

    );
}

const InfoTag = ({ title, label, value }: { label: string; value: string, title?: string; }) => {
    const [isCopying, setIsCopying] = useState(false)
    return (
        <InfoContainer>
            <p className="labelText">{label}</p>
            <Dots />
            <p className="titleText">{title || value}</p>
            {
                isCopying ?
                    <CheckIcon className="checkIcon"
                    />
                    : <img
                        onClick={() => {
                            navigator.clipboard.writeText(value);
                            setIsCopying(true)
                            setTimeout(() => {
                                setIsCopying(false)
                            }, 600);
                        }}
                        className="copyIcon"
                        src={copy_icon}
                        alt=""
                    />
            }
        </InfoContainer>
    );
};